import AppBar from '@mui/material/AppBar';
import {Box, IconButton, Stack, Typography} from "@mui/material";
import logo from "../../../res/raw/logo.png";
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';

const TopAppBar = ({
                       isDarkTheme,
                       onThemeChange,
                   }) => {
    return <>
        <AppBar position="static" color="success">
            <Box position="relative" width="100%">
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    justifyContent="center"
                    left={16}
                    top="50%"
                >
                    <IconButton color="inherit" onClick={onThemeChange}>
                        {isDarkTheme
                            ? <DarkModeIcon fontSize="small"/>
                            : <LightModeIcon fontSize="small"/>
                        }
                    </IconButton>
                    <Typography variant="h6">Blumen</Typography>
                    <img src={logo} alt={"logo"} width={32} height={32}/>
                </Stack>
            </Box>
        </AppBar>
    </>
}

export default TopAppBar;